export function convertImgToBase64(url, width, height) {
  return new Promise((resolve) => {
    var image = new Image(width, height);
    image.crossOrigin = "anonymous"; //getting images from external domain

    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;

      //next three lines for white background in case png has a transparent background
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      canvas.getContext("2d").drawImage(this, 0, 0);

      resolve(canvas.toDataURL("image/jpeg"));
    };

    image.onerror = function (e) {
      console.error("Erro ao carregar a imagem", e);
    };

    image.src = url + "?nocache=" + Date.now();
  });
}
